import { render, staticRenderFns } from "./queryByDoctorIdOrderSum.vue?vue&type=template&id=385c0302&scoped=true&"
import script from "./queryByDoctorIdOrderSum.vue?vue&type=script&lang=js&"
export * from "./queryByDoctorIdOrderSum.vue?vue&type=script&lang=js&"
import style1 from "./queryByDoctorIdOrderSum.vue?vue&type=style&index=1&id=385c0302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c0302",
  null
  
)

export default component.exports